<app-header-toolbar i18n-title="@@PageNotFound.Title" title="Page Not Found" ></app-header-toolbar>
<section class="not-found">
  <div class="not-found__brand">
    <img src="assets/logo.svg" class="not-found__logo" alt="LARS logo" i18n-alt="@@PageNotFoundLogoAlt" />
  </div>
  <div class="not-found__content">
    <div class="not-found__heading">
      <span class="not-found__code" i18n="@@PageNotFound.Code">404</span>
      <p class="not-found__title" i18n="@@PageNotFound.Title">Page Not Found</p>
    </div>
    <img
      src="assets/page-not-found.png"
      class="not-found__smiley-img"
      alt="Friendly face"
      i18n-alt="@@PageNotFound_SmileyAlt"
    />
    <p class="not-found__eyebrow" i18n="@@PageNotFound_Tagline">Oops! Lost in cyberspace?</p>
    <p class="not-found__lead" i18n="@@PageNotFound_Lead">This page took a wrong turn somewhere.</p>
    <p class="not-found__copy" i18n="@@PageNotFound_Copy">But hey, let's get you back on track!</p>
    <button mat-raised-button class="not-found__cta" routerLink="/app/decks" i18n="@@PageNotFound_BackHome">
      Back to homepage
    </button>
  </div>
</section>
